import { useCallback, useEffect, useMemo, useRef } from "react";

import { useHelpBeaconIsOpen } from "Flocknote/stateHooks";

import FnrAccentShineButton from "UI/FnrButton3/FnrAccentShineButton";
import FnrContainedIcon from "UI/FnrContainedIcon";

import { useBackgroundManagerStore } from "Utilities/Hooks/useBackgroundManagerHeight";
import {
  useIsFocusVisible,
  useIsHovered,
} from "Utilities/Hooks/useIsHoverFocused";

import ButtonSizer from "./ButtonSizer";
import { hoverTextKeys, useHoverTextKey } from "./accountAndSettingsStore";

const HelpButton = () => {
  const height = useBackgroundManagerStore((s) => s.height);
  const backgroundManagerIsOpen = useMemo(() => height !== 0, [height]);
  const buttonRef = useRef(null);
  const [, setHoverTextKey] = useHoverTextKey();
  const isHovered = useIsHovered(buttonRef);
  const isFocusVisible = useIsFocusVisible(buttonRef);
  const [helpBeaconIsOpen] = useHelpBeaconIsOpen();

  useEffect(() => {
    if (window.createBeacon) window.createBeacon();
  }, []);

  useEffect(() => {
    if (isHovered || isFocusVisible) setHoverTextKey(hoverTextKeys.help);
    else setHoverTextKey(hoverTextKeys.noHover);
  }, [isHovered, isFocusVisible, setHoverTextKey]);

  const handleClick = useCallback(() => {
    if (backgroundManagerIsOpen) {
      window.backgroundJobCheckerInstance?.showHide();
    }
    window.Beacon("toggle");
  }, [backgroundManagerIsOpen]);

  if (!window.Beacon) return null;
  return (
    <FnrAccentShineButton
      ref={buttonRef}
      onClick={handleClick}
      active={helpBeaconIsOpen}
    >
      <ButtonSizer>
        <FnrContainedIcon
          noPadding
          color="textLight"
          icon="comment-question fas"
        />
      </ButtonSizer>
    </FnrAccentShineButton>
  );
};

export default HelpButton;
